import { Copy } from '@phosphor-icons/react';
import { useMemo } from 'react';
import { toast } from 'react-toastify';
import { ToastWithCustomIcon } from 'src/components/Toast';
import { SVG_SIZE_M } from 'src/constants';
import { Button, ButtonProps } from 'src/v2/commonComponents/Button';

interface CopyCodeButtonProps {
  content: string;
  color?: ButtonProps['color'];
  disabled?: boolean;
}

export const CopyCodeButton = ({
  content,
  disabled,
  color = 'transparent',
}: CopyCodeButtonProps) => {
  const sanitizedText = useMemo(
    () =>
      String(content)
        .replace(/\u00A0/g, ' ')
        .replace(/&nbsp;/g, ' ')
        .replace(/\r\n|\n|\r/g, '\n'),
    [content],
  );

  const handleCopyClick = () => {
    navigator.clipboard.writeText(sanitizedText);

    toast(<ToastWithCustomIcon message="Code Copied" />);
  };

  return (
    <Button
      color={color}
      onClick={handleCopyClick}
      disabled={disabled}
      shape="round"
    >
      <Copy size={SVG_SIZE_M} />
    </Button>
  );
};
